export default {
  'importTransfer.title': 'Import Transfer',
  'importTransfer.uploadComplete': 'Upload has completed.',
  'importTransfer.delete.title': 'Delete Import File',
  'importTransfer.delete.content':
    'You are about to delete an imported file (<%= id %>) and all scheduled transfers will be deleted.',
  'importTransfer.delete.complete': 'Import file (<%= id %>) has been deleted.',
  'importTransfer.approved': 'Import ID (<%= id %>) has been approved',
  'importTransfer.allImports': 'All Imports',
  'importTransfer.addManageImportMaps': 'Add/Manage Import Maps',
  'importTransfer.requiresMyApproval': 'Requires my approval',
  'importTransfer.requiresOthersApproval': 'Requires others approval',
  'importTransfer.tab.messages': 'Import Messages',
  'importTransfer.tab.transfers': 'Transaction Details',
  'importTransfer.sequenceNumber': 'Sequenced Order',
  'importTransfer.lineNumber': 'File Order'
};
